"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../styles/DispatcherStoreDashboard.css");
var _reactRouterDom = require("react-router-dom");
var _DispatcherStoreDashboardComponent = _interopRequireDefault(require("../components/DispatcherStoreDashboardComponent"));
var _strings = require("../common_features/utility/strings");
var _reactRedux = require("react-redux");
var _storesReducer = require("../common_features/redux/reducers/storesReducer");
var _Services = require("../common_features/utility/Services");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _helper = require("../common_features/utility/helper");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DispatcherStoreDashboard = () => {
  const [pageCount, setPageCount] = (0, _react.useState)(1);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const {
    stores
  } = (0, _reactRedux.useSelector)(state => state.stores);
  let storeCount = stores !== undefined && (stores === null || stores === void 0 ? void 0 : stores.length);
  let navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const handleStoreClick = async store => {
    dispatch((0, _storesReducer.selectStore)({
      ...store
    }));
    (0, _Services.getAlerts)(store.storeId).then(res => {
      if (res.success) {
        const payload = {
          storeId: store.storeId,
          data: res.data
        };
        dispatch((0, _alertReducer.alertData)(payload));
      }
    });
    navigate(_RoutePath.default.techDispatcher.useLink);
  };
  const getStoresList = async pgValue => {
    var _storeList$data;
    const storeList = await (0, _Services.getStores)(pgValue);
    return storeList !== null && storeList !== void 0 && (_storeList$data = storeList.data) !== null && _storeList$data !== void 0 && _storeList$data.rows.length ? storeList.data.rows : [];
  };
  const structureAddress = str => {
    // if (!str || typeof str !== "string" || str.includes("{") === false) return ""
    // let addObj = JSON.parse(str)
    // if (Object.keys(addObj).length > 0) {
    // return `${addObj.address1 || ""} ${`, ${addObj.address2 || ""}`} ${`, ${addObj.city || ""}`}${`, ${addObj.state || ""}`}${`, ${addObj.colony || ""}`} ${`, ${addObj.zipcode || ""}`} ${`, ${addObj.country || ""}`}`
    return (0, _helper.isJSON)(str) ? (0, _helper.bindAddress)(JSON.parse(str)) : str;
  };
  (0, _react.useEffect)(async () => {
    dispatch((0, _storesReducer.storesLoading)());
    if (pageCount === 1) {
      dispatch((0, _storesReducer.clearStore)());
    }
    try {
      const alerts = await (0, _Services.GetNotifications)();
      dispatch((0, _alertReducer.generalAlertData)(alerts.data.rows));
    } catch (error) {}
    getUpdateStores(pageCount);
  }, [pageCount]);
  const getUpdateStores = value => {
    getStoresList(value).then(data => {
      let newdatawithAlarm = data.filter(item => item.AlarmCount).map(store => {
        var _store$AlarmCount;
        console.log(store);
        if (store !== null && store !== void 0 && (_store$AlarmCount = store.AlarmCount) !== null && _store$AlarmCount !== void 0 && _store$AlarmCount.length) {
          store.AlarmCount.forEach(row => {
            if (row.severity === 1) {
              store.error = row.count;
            } else if (row.severity === 2) {
              store.error = row.count;
            } else if (row.severity === 3) {
              store.optimize = row.count;
            }
          });
        }
        return store;
      });
      let newdatawithOutAlarm = data.filter(item => !item.AlarmCount || !item.isActive);
      let newdata = newdatawithAlarm.filter(store => store.isActive);
      // newdata = orderBy(newdata, ['error','optimize','info'], ['desc','desc','desc'])
      dispatch((0, _storesReducer.storesInfo)([...newdata, ...newdatawithOutAlarm]));
      setIsLoading(false);
    });
  };
  const onScrollHandler = async e => {
    if (764 + e.target.scrollTop === e.target.scrollHeight) {
      setPageCount(pageCount + 1);
    }
  };
  (0, _react.useEffect)(() => {
    dispatch((0, _storesReducer.clearStore)());
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DispatcherStoreDashboardComponent.default, {
    handleClick: handleStoreClick,
    heading: "HOME DASHBOARD",
    subHeading: "ServiceConnect",
    separator: "|",
    headerText: "Welcome to your Home Dashboard!",
    isLoading: isLoading,
    stores: stores === null || stores === void 0 ? void 0 : stores.map(store => ({
      ...store,
      address: structureAddress(store === null || store === void 0 ? void 0 : store.address)
    })),
    loginType: "dispatcher",
    string: _strings.dispatcherStoreDashboardString,
    title: "Total Stores",
    rightText: storeCount,
    isDisableIcon: _index.default.subscriptionExpireIcon.default,
    isDisableText: "Subscription Expired",
    onScrollHandler: onScrollHandler
  }));
};
var _default = exports.default = DispatcherStoreDashboard;